import { render, staticRenderFns } from "./CartOrders.vue?vue&type=template&id=53494db0&scoped=true"
import script from "./CartOrders.vue?vue&type=script&lang=js"
export * from "./CartOrders.vue?vue&type=script&lang=js"
import style0 from "./CartOrders.vue?vue&type=style&index=0&id=53494db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53494db0",
  null
  
)

export default component.exports